import { compose as originalCompose } from 'recompose';
/**
 * recomposeのcomposeをラップしている関数
 * @deprecated メンテナンスが終了しているライブラリなので、以降は @/utils/lib/redux/compose を利用してください
 * @type {(function(): *)|*}
 */
export const compose = originalCompose;
export default compose;
